export default "__VITE_ASSET__Wmrvi4ea__"